import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  TranslateService as NGXTranslateService,
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { Observable, of, Subject } from 'rxjs';
import { UniversalStorage } from '../storage/universal.storage';


const LANG_LIST: any[] = [
  { code: 'en', name: 'English', culture: 'en-US' },
  { code: 'ar', name: 'Arabic', culture: 'ar-EGY' },
];
const LANG_DEFAULT: any = LANG_LIST[0];
const STORAGE_LANG_NAME = 'langCode';


@Injectable({
  providedIn: 'root'
})

export class TranslatesService {
  public storageLang = new Subject<String>();

  constructor(
    @Inject(DOCUMENT) private _document: any,
    @Inject(NGXTranslateService) private _translate: NGXTranslateService,
    // @Inject(MetaService) private _meta: MetaService,
    @Inject(UniversalStorage) private _appStorage: Storage,
  ) {
  }

  watchStorage(): Observable<any> {
    return this.storageLang.asObservable();
  }


  private _getFindLang(code: string): any | null {
    return code ? LANG_LIST.find((lang: any) => lang.code === code) : null;
  }

  private _setLanguage(lang: any): void {  
    this._translate.use(lang.code).subscribe(() => {
      this._document.documentElement.lang = lang.code;
      this.storageLang.next(lang.code);
    });
  }

  public changeLang(code: string): void {
    const lang: any = this._getFindLang(code);
    if (!lang || lang.code === this._translate.currentLang) {
      return;
    }
    this._appStorage.setItem(STORAGE_LANG_NAME, lang.code);
    this._setLanguage(lang);
    this.toggleDirection(lang);
    this.storageLang.next(lang.code);
  }

  public toggleDirection(lang: any): void {
    const body = document.getElementsByTagName('body')[0];
    const html = document.getElementsByTagName('html')[0];

    html.setAttribute('lang', lang.code);
    if (lang.code === 'ar') {
      body.dir = 'rtl';
      html.dir = 'rtl';
      body.classList.remove('ltr');
      body.classList.add('rtl');
    }
    else {
      body.dir = 'ltr',
      html.dir = 'ltr'
      body.classList.remove('rtl');
      body.classList.add('ltr');
    }
  }

  public getCurrentLang(): string {
    return this._translate.currentLang;
  }

  public getOppositeLang(): string {
    if(this._translate.currentLang == 'en') return 'ar'
    else return 'en'
  }
}

export class CommonMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (
      params.key.match(/\w+\.\w+/) &&
      params.translateService.translations.ru &&
      !params.translateService.translations.ru[params.key]
    ) {
      console.warn(`Нехватает перевода для "${params.key}"`);
    }
    return params.key;
  }
}
